<template>
  <div class="container-fluid bg-light py-3">
    <main class="container-xl">
        <h1>Respaldos en la Nube</h1>
        <p class="mt-4 fs-5">Un proceso automatico que respalda tus archivos en la nube de Microsoft Azure, 
          al cual se le configura la frecuencia y horario para que puedas continuar sin interrupciones tus operaciones del día</p>
        <p>Asi en caso de que se presente la perdida de tu información, ya sea a causa de algun fallo en el hardware o por software malicioso, 
          tendras la oportunidad de restaurarla desde la nube</p>
        <p class="fst-italic">La velocidad con que se realizan los respaldos esta limitada por tu conexión de internet</p>
    </main>
    <div>
      <a href="#" @click.prevent="$emit('verFormDescarga',6)" data-bs-toggle="modal" data-bs-target="#Modal" class="btn btn-success fw-bold me-2">Agenda cita</a>
    </div>
  </div>
</template>

<script>
export default {
    name: 'RespaldosNube'
}
</script>